export const DELETE_PERSON_EMPLOYMENT = "deletePersonEmployment";
export const FETCH_PERSON_EMPLOYMENT_LIST = "fetchPersonEmploymentList";
export const FETCH_PERSONNEL_EMPLOYMENT_LIST = "fetchPersonnelEmployments";
export const SAVE_EDITED_PERSON_EMPLOYMENT = "saveEditPersonEmployment";
export const SAVE_NEW_PERSON_EMPLOYMENT = "saveNewPersonEmployment";
export const UPDATE_PERSON_EMPLOYMENT = "updatePersonEmployment";
